import { graduationRequests } from "api/graduationApi";
import { SelectInput, TextField, useGetList, useRecordContext } from "react-admin";
import { studentRequests } from "api/studentApi";

export const InternshipSessionInput = ({
  source = "internshipSessionId",
  label = "Стажантска сесия",
  filter,
  excludeId,
  ...rest
}) => {
  const { data: sessions, isLoading: isLoadingSessions } = useGetList(
    graduationRequests.getInternshipSessionsSelect(),
    { filter },
  );

  const relevantYearIds = sessions?.map(s => s.academicYearId).filter(Boolean) || [];

  const { data: years, isLoading: isLoadingYears } = useGetList(
    studentRequests.getAcademicYearsSelect(),
    { filter: { Ids: relevantYearIds } },
    { enabled: relevantYearIds.length > 0 },
  );

  const getLabel = session => {
    const year = years?.find(y => y.id === session?.academicYearId);
    return `${session?.typeText} - ${year?.name ?? ""}`;
  };

  const choices = excludeId ? sessions?.filter(s => s.id !== excludeId) : sessions;

  if (isLoadingSessions || isLoadingYears) return null;

  return (
    <SelectInput
      source={source}
      label={label}
      choices={choices}
      emptyText={false}
      optionText={rec => getLabel(rec)}
      {...rest}
    />
  );
};

export const InternshipSessionField = ({ source = "internshipSessionId", label = "Стажантска сесия" }) => {
  const record = useRecordContext();
  const sessionId = record?.[source];

  const { data: sessions } = useGetList(
    graduationRequests.getInternshipSessionsSelect(),
    { filter: { Ids: sessionId ? [sessionId] : [] } },
    { enabled: !!sessionId },
  );
  const session = sessions?.find(s => s.id === record?.[source]);

  const { data: years } = useGetList(
    studentRequests.getAcademicYearsSelect(),
    { filter: { Ids: session?.academicYearId ? [session.academicYearId] : [] } },
    { enabled: !!session?.academicYearId },
  );

  const year = years?.find(y => y.id === session?.academicYearId);
  const value = session ? `${session.typeText} - ${year?.name ?? ""}` : "";

  return (
    <TextField
      source={source}
      record={{ [source]: value }}
      label={label}
    />
  );
};
